import "../../assets/css/font.css.ts.vanilla.mjs";
import { fontColor as o } from "../../assets/css/color.mjs";
const i = {
  size: "medium",
  color: o.active500,
  underline: !1,
  hoverUnderline: !0,
  icon: "icon-new-arrow-right"
}, n = [
  "disabled",
  "onClick",
  "icon",
  "size",
  "color",
  "hoverColor",
  "style",
  "underline",
  "hoverUnderline",
  "className",
  "href"
];
export {
  i as defaultReoLinkProps,
  n as omitPropsKeys
};
//# sourceMappingURL=const.mjs.map
